import { InterestByMarketValue } from '../Interface/Response/Interest/InterestByMarketValue';
import { Cell, HeaderCell, InterestTableDTO, Row } from '../Interface/Hook/Interest/InterestTableDTO';
import { CellDecorator } from '../Enum/TableDecorator';
import { isEmpty } from '../Helpers/String';

const reduceTableByMarketValueData = (interests: InterestByMarketValue): InterestTableDTO => {
    const headers: HeaderCell[] = interests.riskCategories.map(riskCategory => ({
        value: riskCategory.label,
        prop: riskCategory.label,
        sortable: true,
    }));

    headers.unshift({
        value: 'Product',
        prop: 'product',
        sortable: true,
    });

    headers.unshift({
        value: '',
        prop: 'company',
    });

    const data = interests.labels.reduce((acc: Row[], curValue) => {
        if (curValue.interests.every(({ percentage }) => isEmpty(percentage))) {
            return acc;
        }

        const cells: Cell[] = [];
        cells.push({ value: curValue.finDataCode, decorator: CellDecorator.CompanyIcon });
        cells.push({ value: curValue.name });
        curValue.interests.forEach(interest =>
            cells.push({
                value: interest,
                decorator: CellDecorator.Interest,
            }),
        );
        acc.push({ cells });

        return acc;
    }, []);

    return { data, headers };
};

export default reduceTableByMarketValueData;
